import { render } from "./virtualPcSelect.vue?vue&type=template&id=07bbe3ac&scoped=true"
import script from "./virtualPcSelect.vue?vue&type=script&lang=js"
export * from "./virtualPcSelect.vue?vue&type=script&lang=js"

import "./virtualPcSelect.vue?vue&type=style&index=0&id=07bbe3ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bbe3ac"]])

export default __exports__